import React, { Fragment, useCallback, useEffect, useMemo, useState } from "react";
import BreadCrumb from "Common/BreadCrumb";
import CountUp from 'react-countup';
// import Flatpickr from "react-flatpickr";
import moment from "moment";

// icons
import { Boxes, PackagePlus, Search, Plus, MoreHorizontal, FileEdit } from 'lucide-react';
// import { OrdersOverviewChart } from "./charts";
import { Link } from "react-router-dom";
import TableContainer from "Common/TableContainer";

import { Dropdown } from "Common/Components/Dropdown";
import Modal from "Common/Components/Modal";

// react-redux
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';

// Formik
import * as Yup from "yup";
import { useFormik } from "formik";

import {
  onGetCustomOrders,
  onAddCustomOrder,
  onUpdateCustomOrder,
} from 'slices/thunk';
import { ToastContainer } from "react-toastify";
import filterDataBySearch from "Common/filterDataBySearch";
import { currencyFormatter } from "../../helpers/formatter";
import { OrderCustom, doGetOrderStatus } from "../../services/order.service";
import CreatableSelect from 'react-select/creatable';
import { AxiosResponse } from "axios";
import { CustomerModel, doListCustomer } from "../../services/customer.service";
import { Setting } from "../../services/user.service";
import { OrderStatusHelper } from "../../Common/Components/Status";
import DropZoneImage from "../../Common/Components/Dropzone";
import CustomOrderProductModal from "./CustomOrderProductItem";


const CustomOrders = () => {

  const dispatch = useDispatch<any>();

  const selectDataList = createSelector(
    (state: any) => state.Ecommerce,
    (state) => ({
      dataList: state.customOrders
    })
  );

  const { dataList } = useSelector(selectDataList);

  const [data, setData] = useState<any>([]);
  const [eventData, setEventData] = useState<any>();

  const [show, setShow] = useState<boolean>(false);
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [isOpenProductModal, setIsOpenProductModal] = useState<boolean>(false);
  const [order, setOrder] = useState<OrderCustom>();

  const [customerList, setCustomerList] = useState<CustomerModel[]>([]);
  const [customerDroplist, setCustomerDropList] = useState<Array<{ value: string, label: string }>>([]);

  const [orderStatusList, setOrderStatusList] = useState<Setting[]>([]);
  const [selectfiles, setSelectfiles] = useState<Array<File & { base64: string }>>([]);

  useEffect(() => {
    handleGetOrderStatus()
    handleListAllCustomers()
  }, [])

  // Get Data
  useEffect(() => {
    dispatch(onGetCustomOrders());
  }, [dispatch]);

  useEffect(() => {
    setData(dataList);
  }, [dataList]);

  const handleListAllCustomers = () => {
    doListCustomer(0).then((res) => {
      const response = res as AxiosResponse
      const customers = response.data
      setCustomerList(customers)
      setCustomerDropList(customers.map((customer: CustomerModel) => {
        return {
          value: customer.customerId,
          label: customer.name
        }
      }))
    })
  }

  const handleGetOrderStatus = () => {
    doGetOrderStatus().then((res) => {
      const response = res as AxiosResponse
      setOrderStatusList(response.data)
    })
  }

  // Update Data
  const handleUpdateDataClick = (ele: any) => {
    const data = {
      ...ele,
      customerId: ele.customer?.customerId,
      customerName: ele.customer?.name,
      customerAddress: ele.customer?.address,
      customerPhoneNo: ele.customer?.phoneNo,
    }
    setEventData(data);
    setIsEdit(true);
    setShow(true);
  };

  const handleChangeCustomer = (selectedOption: any) => {
    if (selectedOption?.value) {
      const customer = customerList.find((customer: CustomerModel) => customer.customerId === selectedOption.value)
      if (customer) {
        validation.setFieldValue('customerId', customer?.customerId)
        validation.setFieldValue('customerName', customer?.name)
        validation.setFieldValue('customerAddress', customer?.address)
        validation.setFieldValue('customerPhoneNo', customer?.phoneNo)
      }
    }
  }

  // validation
  const validation: any = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      orderCustomId: (eventData && eventData.orderCustomId) || '',
      customerId: (eventData && eventData.customerId) || '',
      customerName: (eventData && eventData.customerName) || '',
      customerAddress: (eventData && eventData.customerAddress) || '',
      customerPhoneNo: (eventData && eventData.customerPhoneNo) || '',
      orderDetails: (eventData && eventData.orderDetails) || [],
      deliveryMethod: (eventData && eventData.deliveryMethod) || '',
      image: (eventData && eventData.image) || [],
      files: (eventData && eventData.files) || [],
      description: (eventData && eventData.description) || '',
      quantity: (eventData && eventData.quantity) || '',
      subtotal: (eventData && eventData.subtotal) || '',
    },
    validationSchema: Yup.object({
      orderCustomId: Yup.string().optional(),
      customerId: Yup.string().required("Please Select Customer"),
      customerName: Yup.string().required("Please Enter Customer Name"),
      customerAddress: Yup.string().required("Please Enter Customer Address"),
      customerPhoneNo: Yup.string().required("Please Enter Customer Phone No"),
      deliveryMethod: Yup.string().required("Please Select Delivery Method"),
      image: Yup.array().optional(),
      description: Yup.string().required("Please Enter Product Description"),
      quantity: Yup.string().required("Please Enter Quantity"),
      subtotal: Yup.string().required("Please Enter Total Amount"),
    }),

    onSubmit: (values) => {
      const image = []
      if (selectfiles.length > 0) image.push(...selectfiles)
      if (values.image.length > 0) image.push(...values.image)

      const data = {
        ...values,
        image
      };
      if (isEdit) {
        dispatch(onUpdateCustomOrder(data));
      } else {
        delete data.orderCustomId
        dispatch(onAddCustomOrder(data));
      }
      toggle();
    },
  });

  //
  const toggle = useCallback(() => {
    if (show) {
      setShow(false);
      setEventData("");
      setIsEdit(false);
      setSelectfiles([]);
    } else {
      setShow(true);
      setEventData("");
      setSelectfiles([]);
      validation.resetForm();
    }
  }, [show, validation]);

  // Search Data
  const filterSearchData = (e: any) => {
    const search = e.target.value;
    const keysToSearch = ['orderCustomId', 'userId', 'status'];
    filterDataBySearch(dataList, search, keysToSearch, setData);
  };

  const [activeTab, setActiveTab] = useState("1");

  const toggleTab = (tab: any, type: any) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
      let filteredOrders = dataList;
      if (type !== "all") {
        filteredOrders = dataList.filter((order: any) => order.status === type);
      }
      setData(filteredOrders);
    }
  };

  const columns = useMemo(() => [
    {
      header: (
        <div className="flex items-center h-full">
          <input id="CheckboxAll" className="w-4 h-4 cursor-pointer bg-white border border-slate-200 checked:bg-none dark:bg-zink-700 dark:border-zink-500 rounded-sm appearance-none arrow-none relative after:absolute after:content-['\eb7b'] after:top-0 after:left-0 after:font-remix after:leading-none after:opacity-0 checked:after:opacity-100 after:text-custom-500 checked:border-custom-500 dark:after:text-custom-500 dark:checked:border-custom-800" type="checkbox" />
        </div>
      ),
      enableSorting: false,
      id: "checkAll",
      cell: (cell: any) => {
        return (
          <div className="flex items-center h-full">
            <input id={"Checkbox" + cell.row.original.orderCustomId} className="w-4 h-4 cursor-pointer bg-white border border-slate-200 checked:bg-none dark:bg-zink-700 dark:border-zink-500 rounded-sm appearance-none arrow-none relative after:absolute after:content-['\eb7b'] after:top-0 after:left-0 after:font-remix after:leading-none after:opacity-0 checked:after:opacity-100 after:text-custom-500 checked:border-custom-500 dark:after:text-custom-500 dark:checked:border-custom-800" type="checkbox" />
          </div>
        );
      }
    },
    {
      header: "Order ID",
      accessorKey: "orderCode",
      enableColumnFilter: false,
      enableSorting: false,
      cell: (cell: any) => (
        <>
          <Link to="#!" className="transition-all duration-150 ease-linear order_id text-custom-500 hover:text-custom-600"
            onClick={() => {
              setOrder(cell.row.original)
              setIsOpenProductModal(true)
            }}>
            {cell.getValue() || '-'}
          </Link>
        </>
      ),
    },
    {
      header: "Order Date",
      accessorKey: "createdAt",
      enableColumnFilter: false,
      cell: (cell: any) => {
        return (
          <span>
            {moment(cell.getValue()).format("DD MMM YYYY")}
          </span>
        )
      },
    },
    // {
    //   header: "Delivery Date",
    //   accessorKey: "deliveryDate",
    //   enableColumnFilter: false,
    //   cell: (cell: any) => {
    //     return (
    //       <span>
    //         {cell.getValue() ? moment(cell.getValue()).format("DD MMM YYYY") : '-'}
    //       </span>
    //     )
    //   },
    // },
    {
      header: "Customer",
      accessorKey: "customer",
      enableColumnFilter: false,
      enableSorting: true,
      cell: (cell: any) => {
        return (
          <span>
            {cell.row.original.customer?.name}
          </span>
        )
      },
    },
    {
      header: "Amount",
      accessorKey: "subtotal",
      enableColumnFilter: false,
      enableSorting: false,
      cell: (cell: any) => {
        const total = cell.getValue()

        return (
          currencyFormatter(total)
        )
      },
    },
    {
      header: "Status",
      accessorKey: "status",
      enableColumnFilter: false,
      enableSorting: true,
      cell: (cell: any) => (
        <OrderStatusHelper status={cell.getValue()} list={orderStatusList} />
      ),
    },
    {
      header: "Action",
      enableColumnFilter: false,
      enableSorting: true,
      cell: (cell: any) => (
        <Dropdown className="relative">
          <Dropdown.Trigger id="orderAction1" data-bs-toggle="dropdown" className="flex items-center justify-center w-[30px] h-[30px] p-0 text-slate-500 btn bg-slate-100 hover:text-white hover:bg-slate-600 focus:text-white focus:bg-slate-600 focus:ring focus:ring-slate-100 active:text-white active:bg-slate-600 active:ring active:ring-slate-100 dark:bg-slate-500/20 dark:text-slate-400 dark:hover:bg-slate-500 dark:hover:text-white dark:focus:bg-slate-500 dark:focus:text-white dark:active:bg-slate-500 dark:active:text-white dark:ring-slate-400/20"><MoreHorizontal className="w-3 h-3" /></Dropdown.Trigger>
          <Dropdown.Content placement={cell.row.index ? "top-end" : "right-end"} className="absolute z-50 py-2 mt-1 ltr:text-left rtl:text-right list-none bg-white rounded-md shadow-md min-w-[10rem] dark:bg-zink-600" aria-labelledby="orderAction1">
            <li>
              <Link to="#!" data-modal-target="addOrderModal" className="block px-4 py-1.5 text-base transition-all duration-200 ease-linear text-slate-600 hover:bg-slate-100 hover:text-slate-500 focus:bg-slate-100 focus:text-slate-500 dark:text-zink-100 dark:hover:bg-zink-500 dark:hover:text-zink-200 dark:focus:bg-zink-500 dark:focus:text-zink-200" onClick={() => {
                const data = cell.row.original;
                handleUpdateDataClick(data);
              }}>
                <FileEdit className="inline-block w-3 h-3 ltr:mr-1 rtl:ml-1" /> <span className="align-middle">Edit</span></Link>
            </li>
          </Dropdown.Content>
        </Dropdown>
      ),
    }
  ], [orderStatusList]
  );

  return (
    <React.Fragment>
      <BreadCrumb title='Order Lists' pageTitle='Ecommerce' />
      <ToastContainer closeButton={false} limit={1} />
      <CustomOrderProductModal
        isOpen={isOpenProductModal}
        setIsOpen={setIsOpenProductModal}
        order={order}
        setOrder={setOrder}
        orderStatusList={orderStatusList} />
      <div className="grid grid-cols-1 gap-x-5 md:grid-cols-2 2xl:grid-cols-12">
        <div className="2xl:col-span-2 2xl:row-span-1">
          <div className="card">
            <div className="flex items-center gap-3 card-body">
              <div className="flex items-center justify-center w-12 h-12 rounded-md text-15 bg-custom-50 text-custom-500 dark:bg-custom-500/20 shrink-0"><Boxes /></div>
              <div className="grow">
                <h5 className="mb-1 text-16">
                  <CountUp end={data.length} separator="," className="counter-value" />
                </h5>
                <p className="text-slate-500 dark:text-zink-200">Total Orders</p>
              </div>
            </div>
          </div>
        </div>
        {
          orderStatusList?.map((status: Setting, index: number) => (
            <div className="2xl:col-span-2 2xl:row-span-1" key={index}>
              <div className="card">
                <div className="flex items-center gap-3 card-body">
                  <div className="flex items-center justify-center w-12 h-12 rounded-md text-15 bg-sky-50 text-sky-500 dark:bg-sky-500/20 shrink-0"><PackagePlus /></div>
                  <div className="grow">
                    <h5 className="mb-1 text-16">
                      <CountUp end={data.filter((order: any) => [status.code].includes(order.status)).length} separator="," className="counter-value" />
                    </h5>
                    <p className="text-slate-500 dark:text-zink-200">{status.value}</p>
                  </div>
                </div>
              </div>
            </div>
          ))
        }
        {/* <div className="order-last md:col-span-2 2xl:col-span-8 2xl:row-span-3 card 2xl:order-none">
          <div className="card-body">
            <h6 className="mb-4 text-gray-800 text-15 dark:text-zink-50">Orders Overview</h6>
            <OrdersOverviewChart id="ordersOverview" />
          </div>
        </div> */}
      </div>

      <div className="card" id="ordersTable">
        <div className="card-body">
          <div className="grid grid-cols-1 gap-4 lg:grid-cols-12">
            <div className="lg:col-span-3">
              <div className="relative">
                <input type="text" className="ltr:pl-8 rtl:pr-8 search form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200" placeholder="Search for ..." autoComplete="off" onChange={(e) => filterSearchData(e)} />
                <Search className="inline-block w-4 h-4 absolute ltr:left-2.5 rtl:right-2.5 top-2.5 text-slate-500 dark:text-zink-200 fill-slate-100 dark:fill-zink-600" />
              </div>
            </div>
            <div className="lg:col-span-2 lg:col-start-11">
              <div className="ltr:lg:text-right rtl:lg:text-left">
                <Link to="#!" data-modal-target="addOrderModal" type="button" className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20" onClick={toggle}>
                  <Plus className="inline-block w-4 h-4" /> <span className="align-middle">Add Order</span>
                </Link>
              </div>
            </div>
          </div>

          <ul className="flex flex-wrap w-full mt-5 text-sm font-medium text-center text-gray-500 nav-tabs">
            <li className={`group ${activeTab === "1" && "active"}`}>
              <Link to="#" data-tab-toggle data-target="allOrders" className="inline-block px-4 py-1.5 text-base transition-all duration-300 ease-linear rounded-md text-slate-500 dark:text-zink-200 border border-transparent group-[.active]:bg-custom-500 group-[.active]:text-white dark:group-[.active]:text-white hover:text-custom-500 dark:hover:text-custom-500 active:text-custom-500 dark:active:text-custom-500 -mb-[1px]" onClick={() => { toggleTab("1", "all"); }}>
                <Boxes className="inline-block w-4 h-4 ltr:mr-1 rtl:ml-1" /> <span className="align-middle">All Orders</span>
              </Link>
            </li>
            {
              orderStatusList?.map((status: Setting, index: number) => (
                <li className={`group ${activeTab === (index + 2).toString() && "active"}`} key={index}>
                  <Link to="#" data-tab-toggle data-target={`${status.code.replace(' ', '')}Order`} className="inline-block px-4 py-1.5 text-base transition-all duration-300 ease-linear rounded-md text-slate-500 dark:text-zink-200 border border-transparent group-[.active]:bg-custom-500 group-[.active]:text-white dark:group-[.active]:text-white hover:text-custom-500 dark:hover:text-custom-500 active:text-custom-500 dark:active:text-custom-500 -mb-[1px]"
                    onClick={() => { toggleTab((index + 2).toString(), status.code); }}>
                    <Boxes className="inline-block w-4 h-4 ltr:mr-1 rtl:ml-1" /> <span className="align-middle">{status.value}</span>
                  </Link>
                </li>
              ))
            }
          </ul>

          {data && data.length > 0 ?
            <TableContainer
              isPagination={true}
              columns={(columns || [])}
              data={(data || [])}
              customPageSize={10}
              divclassName="mt-5 overflow-x-auto"
              tableclassName="w-full whitespace-nowrap"
              theadclassName="ltr:text-left rtl:text-right bg-slate-100 dark:bg-zink-600"
              thclassName="px-3.5 py-2.5 font-semibold text-slate-500 border-b border-slate-200 dark:border-zink-500 dark:text-zink-200"
              tdclassName="px-3.5 py-2.5 border-y border-slate-200 dark:border-zink-500"
              PaginationClassName="flex flex-col items-center mt-5 md:flex-row"
            />
            :
            (<div className="noresult">
              <div className="py-6 text-center">
                <Search className="w-6 h-6 mx-auto text-sky-500 fill-sky-100 dark:sky-500/20" />
                <h5 className="mt-2 mb-1">Sorry! No Result Found</h5>
                <p className="mb-0 text-slate-500 dark:text-zink-200">We've searched more than 299+ orders We did not find any orders for you search.</p>
              </div>
            </div>)}
        </div>
      </div>


      {/* Order Modal */}

      <Modal show={show} onHide={toggle} modal-center="true"
        className="fixed flex flex-col transition-all duration-300 ease-in-out left-2/4 z-drawer -translate-x-2/4 -translate-y-2/4"
        dialogClassName="w-screen md:w-[70rem] bg-white shadow rounded-md dark:bg-zink-600">
        <Modal.Header className="flex items-center justify-between p-4 border-b dark:border-zink-500"
          closeButtonClass="transition-all duration-200 ease-linear text-slate-400 hover:text-red-500">
          <Modal.Title className="text-16">{!!isEdit ? "Edit Order" : "Add Order"}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="max-h-[calc(theme('height.screen')_-_180px)] p-4 overflow-y-auto">
          <form action="#!" onSubmit={(e) => {
            e.preventDefault();
            validation.handleSubmit();
            return false;
          }}>
            <div className="grid grid-cols-1 gap-4 xl:grid-cols-12">
              <div className="xl:col-span-6">
                <label htmlFor="customerNameInput" className="inline-block mb-2 text-base font-medium">Customer Name</label>
                <CreatableSelect isClearable
                  name="customerId"
                  options={customerDroplist}
                  onChange={(selectedOption) => handleChangeCustomer(selectedOption)}
                  value={customerDroplist.find(option => option.value === validation.values.customerId)}
                  isDisabled={isEdit}
                />
                {validation.touched.customerName && validation.errors.customerName ? (
                  <p className="text-red-400">{validation.errors.customerName}</p>
                ) : null}
              </div>
              <div className="xl:col-span-6">
                <label htmlFor="customerPhoneNoInput" className="inline-block mb-2 text-base font-medium">Customer Phone No</label>
                <input type="text" id="customerPhoneNoInput" className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                  placeholder="Customer Phone No"
                  name="customerPhoneNo"
                  onChange={validation.handleChange}
                  value={validation.values.customerPhoneNo || ""}
                />
                {validation.touched.customerPhoneNo && validation.errors.customerPhoneNo ? (
                  <p className="text-red-400">{validation.errors.customerPhoneNo}</p>
                ) : null}
              </div>
              <div className="xl:col-span-12">
                <label htmlFor="customerAddressInput" className="inline-block mb-2 text-base font-medium">Customer Address</label>
                <input type="text" id="customerAddressInput" className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                  placeholder="Customer Address"
                  name="customerAddress"
                  onChange={validation.handleChange}
                  value={validation.values.customerAddress || ""}
                />
                {validation.touched.customerAddress && validation.errors.customerAddress ? (
                  <p className="text-red-400">{validation.errors.customerAddress}</p>
                ) : null}
              </div>
              <div className="xl:col-span-6">
                <label htmlFor="customerPhoneNoInput" className="inline-block mb-2 text-base font-medium">Delivery Method</label>
                <div className="grid grid-cols-1 gap-5 xl:grid-cols-2">
                  <div className="flex items-center gap-3">
                    <input id="deliveryOption1" className="w-4 h-4 border rounded-full appearance-none cursor-pointer bg-slate-100 border-slate-200 dark:bg-zink-600 dark:border-zink-500 checked:bg-purple-500 checked:border-purple-500 dark:checked:bg-purple-500 dark:checked:border-purple-500 checked:disabled:bg-purple-400 checked:disabled:border-purple-400 peer"
                      type="radio"
                      name="deliveryMethod"
                      value="delivery"
                      checked={validation.values.deliveryMethod === 'delivery'}
                      onChange={validation.handleChange} />
                    <label htmlFor="deliveryOption1" className="flex flex-col gap-4 p-5 border rounded-md cursor-pointer md:flex-row border-slate-200 dark:border-zink-500 peer-checked:border-purple-500 dark:peer-checked:border-purple-700 grow">
                      <span className="grow">
                        <span className="block mb-1 font-semibold text-15">Delivery</span>
                      </span>
                    </label>
                  </div>
                  <div className="flex items-center gap-3">
                    <input id="deliveryOption2" className="w-4 h-4 border rounded-full appearance-none cursor-pointer bg-slate-100 border-slate-200 dark:bg-zink-600 dark:border-zink-500 checked:bg-purple-500 checked:border-purple-500 dark:checked:bg-purple-500 dark:checked:border-purple-500 checked:disabled:bg-purple-400 checked:disabled:border-purple-400 peer"
                      type="radio"
                      name="deliveryMethod"
                      value="pickup"
                      checked={validation.values.deliveryMethod === 'pickup'}
                      onChange={validation.handleChange} />
                    <label htmlFor="deliveryOption2" className="flex flex-col gap-4 p-5 border rounded-md cursor-pointer md:flex-row border-slate-200 dark:border-zink-500 peer-checked:border-purple-500 dark:peer-checked:border-purple-700 grow">
                      <span className="grow">
                        <span className="block mb-1 font-semibold text-15">Pick Up</span>
                      </span>
                    </label>
                  </div>
                </div>
                {validation.touched.deliveryMethod && validation.errors.deliveryMethod ? (
                  <p className="text-red-400">{validation.errors.deliveryMethod}</p>
                ) : null}
              </div>
              <div className="xl:col-span-12">
                <label htmlFor="imageInput" className="inline-block mb-2 text-base font-medium">Image</label>
                <DropZoneImage selectfiles={selectfiles} setSelectfiles={setSelectfiles} formikData={validation} fieldName='image' files={validation.values.files} />
                {validation.touched.customerAddress && validation.errors.image ? (
                  <p className="text-red-400">{validation.errors.image}</p>
                ) : null}
              </div>
              <div className="xl:col-span-12">
                <label htmlFor="descriptionInput" className="inline-block mb-2 text-base font-medium">Description</label>
                <input type="text" id="descriptionInput" className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                  placeholder="Product Description"
                  name="description"
                  onChange={validation.handleChange}
                  value={validation.values.description || ""}
                />
                {validation.touched.description && validation.errors.description ? (
                  <p className="text-red-400">{validation.errors.description}</p>
                ) : null}
              </div>
              <div className="xl:col-span-6">
                <label htmlFor="quantityInput" className="inline-block mb-2 text-base font-medium">Quantity</label>
                <input type="text" id="quantityInput" className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                  placeholder="Quantity"
                  name="quantity"
                  onChange={validation.handleChange}
                  value={validation.values.quantity || ""}
                />
                {validation.touched.quantity && validation.errors.quantity ? (
                  <p className="text-red-400">{validation.errors.quantity}</p>
                ) : null}
              </div>
              <div className="xl:col-span-6">
                <label htmlFor="subtotalInput" className="inline-block mb-2 text-base font-medium">Total Amount</label>
                <input type="text" id="subtotalInput" className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                  placeholder="Total Amount"
                  name="subtotal"
                  onChange={validation.handleChange}
                  value={validation.values.subtotal || ""}
                />
                {validation.touched.subtotal && validation.errors.subtotal ? (
                  <p className="text-red-400">{validation.errors.subtotal}</p>
                ) : null}
              </div>
            </div>
            <div className="flex justify-end gap-2 mt-4">
              <button type="reset" className="text-red-500 bg-white btn hover:text-red-500 hover:bg-red-100 focus:text-red-500 focus:bg-red-100 active:text-red-500 active:bg-red-100 dark:bg-zink-600 dark:hover:bg-red-500/10 dark:focus:bg-red-500/10 dark:active:bg-red-500/10" onClick={toggle}>Cancel</button>
              <button
                type="submit"
                className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                disabled={validation.isSubmitting}
              >
                {!!isEdit ? "Update" : "Add Order"}
              </button>
            </div>
          </form>
        </Modal.Body>
      </Modal>

    </React.Fragment >
  );
};

export default CustomOrders;